<section class="parallax_blog">
  <div class="caption">
    <h1 class="border display-5 fw-bold">Stories &amp; Travel Guides</h1>
  </div>
</section>

<main class="blog-page">
  <div class="container">
    <header class="blog-head">
      <h3 class="fw-bold">Latest Articles</h3>
      <p>Tips, routes and tales from our crew sailing Komodo, Raja Ampat, Banda and Alor.</p>
    </header>

    <div class="chips" role="group" aria-label="Filter by category" *ngIf="categories.length > 1">
      <button type="button" class="chip" [class.on]="selectedCategory === ''" [attr.aria-pressed]="selectedCategory === ''"
        (click)="selectCategory('')">All</button>
      <button type="button" class="chip" *ngFor="let c of categories" [class.on]="selectedCategory === c"
        [attr.aria-pressed]="selectedCategory === c" (click)="selectCategory(c)">{{ c }}</button>
    </div>

    <!-- Loading -->
    <div class="grid" *ngIf="loading" aria-busy="true">
      <div class="card-sk" *ngFor="let s of skeletons">
        <span class="sk media"></span>
        <span class="sk line w-80"></span>
        <span class="sk line w-50"></span>
      </div>
    </div>

    <!-- Error -->
    <div class="state" *ngIf="!loading && error">
      <p>We couldn't load articles right now.</p>
      <button type="button" class="btn-outline" (click)="load(true)">Try again</button>
    </div>

    <!-- Empty -->
    <div class="state" *ngIf="!loading && !error && !articles.length">
      <p>No articles here yet. Check back soon for new stories from the sea.</p>
      <a routerLink="/home" class="btn-outline">Back to home</a>
    </div>

    <!-- Articles -->
    <div class="grid" *ngIf="!loading && articles.length">
      <article class="post" *ngFor="let article of articles; trackBy: trackById">
        <a class="post-link" [routerLink]="['/blog', article.slug]">
          <div class="post-media">
            <img [src]="articleService.coverUrl(article)" [alt]="article.title" loading="lazy">
          </div>
          <h2 class="post-title">{{ article.title }}</h2>
          <p class="post-excerpt">{{ article.excerpt }}</p>
          <p class="post-meta">
            <span *ngIf="article.category">{{ article.category }}</span>
            <span>{{ articleService.formatDate(article.published_at) }}</span>
            <span>{{ article.reading_minutes }} min read</span>
          </p>
        </a>
      </article>
    </div>

    <div class="more" *ngIf="!loading && page < totalPages">
      <button type="button" class="btn-outline" (click)="loadMore()" [disabled]="loadingMore">
        {{ loadingMore ? 'Loading…' : 'Load more articles' }}
      </button>
    </div>
  </div>
</main>

<app-smartch></app-smartch>
<app-review></app-review>
<app-review-b></app-review-b>
<app-footer></app-footer>
